import React from 'react';
import { useSelector} from "react-redux";
import {
    bbFormattedDateString, bbShortenString,
    mapObject
} from "../../../../util/bbHelpers";
import ArrayDataTable from "../../tables/ArrayDataTable";
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";

import SendSharpIcon from '@material-ui/icons/SendSharp';
import EmailSharpIcon from '@material-ui/icons/EmailSharp';

import DraftsSharpIcon from '@material-ui/icons/DraftsSharp';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
}));

const TableContainer = (props) => {

  const {customerId, campaignId} = props;

  // const classes = useStyles();

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCampaigns, loadingCampaignsError} = useSelector(({customer}) => customer);
  // const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customerId ? customers[customerId] : null : null;
  //from the customer, pull the ACTIVE target data if it exists
  const campaigns = customer ? customer.campaigns ? customer.campaigns : null : null;
  const {
      [campaignId] : {
          Attacks
      }
  } = campaigns

  const attacksBatchSize = 10
  const totalNumAttacks = Object.keys(Attacks).length

  // useEffect(() => {
  //   console.log("PhishingAttacks Table for customerId: ", customerId, " customer: ", customer, " Attacks: ", Attacks)
  //
  // }, [customers]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <>
        Phishing Attacks for this Vector <Tooltip title={"The following phishing attacks were all performed in an effort to achieve a breach via this vector. If there are no attacks in this table, then attack activity has not yet started."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </>;

  const userTableHeadings = [
      "Status",
      "Date",
      "Subject",
      "Target",
      "Source",
      // "Status",

  ];

    //peel the state data into a form the dataTable can read
  const tableData = Attacks ? mapObject(Attacks, (key, attack) => {
      const isBasicItem = attack.hasOwnProperty("Details")
      const originComponent = isBasicItem //campaign
              ? <Tooltip title={attack.Details["Source Email Address"] }><span><code>{bbShortenString(attack.Details["Source Email Address"] , 25, true)}</code></span></Tooltip>
              : <Tooltip title={attack["Phishing Attack Detail"]["Phishing Profile"]["Sender"]["Username"] }><span><code>{bbShortenString(attack["Phishing Attack Detail"]["Phishing Profile"]["Sender"]["Username"] , 25, true)}</code></span></Tooltip>

      const targetComponent = isBasicItem //campaign
              ? <Tooltip title={attack.Details["Target Email Address"] }><span><code>{bbShortenString(attack.Details["Target Email Address"], 25, true)}</code></span></Tooltip>
              : <Tooltip title={attack["Phishing Attack Detail"]["Target Details"]["Email Address"] }><span><code>{bbShortenString(attack["Phishing Attack Detail"]["Target Details"]["Email Address"] , 25, true)}</code></span></Tooltip>

      const emailComponent = isBasicItem //campaign
          ? <Tooltip title={attack.Details["Email Subject"] }><span><code>{bbShortenString(attack.Details["Email Subject"], 25, true)}</code></span></Tooltip>
          : <Tooltip title={attack["Phishing Attack Detail"]["Phishing Profile"]["Email Subject"] }><span><code>{bbShortenString(attack["Phishing Attack Detail"]["Phishing Profile"]["Email Subject"], 25, true)}</code></span></Tooltip>

      return (
        {
            id: attack.AttackId ? attack.AttackId: key,
            Status: <Tooltip title={attack["Access Gained"] ? `Attack achieved breach: ${bbFormattedDateString(attack["Access Gained DateTime"], "long")}. ${attack.Status.Description}` : `Status: ${attack.Status.Description}`}><span>{attack["Access Gained"] ? <DraftsSharpIcon className={"text-danger"}/> : attack.Status.Id === 0 ? <SendSharpIcon/> : <EmailSharpIcon className={"text-warning"}/>}</span></Tooltip>,
            Date: attack["Start DateTime"]
                ? <Tooltip title={bbFormattedDateString(attack["Start DateTime"], "long")}><span>{bbFormattedDateString(attack["Start DateTime"], "monthDayTime")}</span></Tooltip>
                : <Tooltip title={bbFormattedDateString(attack["Access Gained DateTime"], "long")}><span>{bbFormattedDateString(attack["Access Gained DateTime"], "monthDayTime")}</span></Tooltip>,
            Subject: emailComponent,
            Target: targetComponent,
            Source: originComponent,
            // Status: <Tooltip title={`Status: ${attack.Status.Description}`}><span>{bbShortenString(attack.Status.Name, 20, true)}</span></Tooltip>,
        }
    )
  }) : null;

  // const ghostRowFetchFunction = (pageNumber) => {
  //     console.log("ghostRowFetchFunction in VectorAttacksTable called with page number", pageNumber)
  //     dispatch(fetchAttacksAction({
  //         customerId: customer.CustomerId,
  //         campaignId: campaignId,
  //         pageNumber: pageNumber
  //     }));
  //
  // }

  const tableDataAsArray = () => {
      // console.log("Creating targetsTableData as array from targetTableData ", tableData);
      let i=0, arr=[];
      for (let ob in tableData) {
          // console.log("ob is ", tableData[ob])
          arr[i++]=tableData[ob];
      }

      //TODO: sort by date, and encode date into the data so the frontend can sort.

      // const arrayWithGhosts = bbAppendRowPlaceholdersToTableDataArray(arr, totalNumAttacks, attacksBatchSize, ghostRowFetchFunction);
      // console.log("Added ghosts to the vector attacks data array.  result: ", arrayWithGhosts)

      return arr;
  }


  if ((Attacks) && !loadingCampaignsError) {
    // console.log("TargetsTable loading is finished here is the customers in the store", customers, "and table data", tableDataAsArray())
    return (
        <div className={""} >
            <ArrayDataTable tableData={tableDataAsArray()} columnHeaders={userTableHeadings} overrideRowsPerPage = {attacksBatchSize} title={title} maxRecordsDisplayOverride = {totalNumAttacks}/>
        </div>
    );
  } else if (loadingCampaigns) {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {attacksBatchSize} title={title} loading={true} numSkeletonRows={3}/>
        </div>
    );

  } else {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {attacksBatchSize} title={title} loading={true} numSkeletonRows={3}/>
        </div>

    );
  }


}
TableContainer.propTypes = {
    customerId: PropTypes.string.isRequired,
    campaignId: PropTypes.string.isRequired,
};

export default TableContainer